export default __webpack_public_path__ + "static/media/logo.1ffe1f26.png";